import { useMemo } from 'react';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Login } from 'pages/Login';
import { Terms } from 'pages/Terms';
import { Privacy } from 'pages/Privacy';

import { Store } from 'types';

import { DashboardRouter } from './DashboardRouter';
import { Routes } from './routes';

export const Router = () => {
  const { data } = useSelector((store: Store) => store.user);

  const memoizedRoutes = useMemo(() => {
    if (!data) {
      return (
        <Switch>
          <Route exact path={Routes.login} component={Login} />
          <Route exact path={Routes.terms} component={Terms} />
          <Route exact path={Routes.privacy} component={Privacy} />
          <Route path="*">
            <Redirect to={Routes.login} />
          </Route>
        </Switch>
      );
    }

    return (
      <Switch>
        <Route path={Routes.dashboard} component={DashboardRouter} />
        <Route exact path={Routes.terms} component={Terms} />
        <Route exact path={Routes.privacy} component={Privacy} />
        <Route path="*">
          <Redirect to={Routes.dashboard} />
        </Route>
      </Switch>
    );
  }, [data]);

  return <BrowserRouter>{memoizedRoutes}</BrowserRouter>;
};
